var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"tag":"div","appear":"","name":"from-right-to-left","mode":"out-in"}},[(_vm.showRecent)?_c('FilesDashboardRecent'):_c('FilesDashboardRoot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }